import type { ComboboxItem, HighlightType } from '@node-space/ui-components'
import { CustomerV2Status } from 'types/customers'

export const statusHighlightTypeMap: Partial<Record<CustomerV2Status, HighlightType>> = {
  VERIFIED: 'success',
  INFO_REQUIRED: 'warning',
  ACTIONS_REQUIRED: 'warning',
  PENDING: 'neutral',
  REJECTED: 'error',
  TERMINATED: 'error',
}

export const customerTypeHighlightMap: Partial<Record<string, HighlightType>> = {
  INDIVIDUAL: 'feature',
}

export const customerTypeLabelMap: Record<string, string> = {
  COMPANY: 'Business',
  INDIVIDUAL: 'Individual',
}

export const statusLabelMap: Partial<Record<CustomerV2Status, string>> = {
  INFO_REQUIRED: 'Info Required',
  PENDING: 'Pending',
  ACTIONS_REQUIRED: 'Actions Required',
  REJECTED: 'Rejected',
  TERMINATED: 'Terminated',
}

export const CUSTOMERS_V2_DEFAULT_STATUSES = Object.keys(statusLabelMap) as CustomerV2Status[]

export const getOptions = (
  map: Record<string, string>,
  translationPrefix: string,
  t: (key: string) => string
) =>
  Object.keys(map).map(key => ({
    value: map[key],
    leftText: t(`${translationPrefix}.${key}`),
  }))

export const findLabel = (items: ComboboxItem[], value: string | undefined): string | undefined =>
  items.find(item => item.value === value)?.leftText as string | undefined

export const booleanDisplay = (value: string | undefined, yes: string, no: string): string => {
  if (value === 'true') return yes
  if (value === 'false') return no
  return ''
}
